<template>
  <v-dialog v-model="dialog"
            persistent
            @keydown.esc="close"
            max-width="900px" max-height="965px"
  >
    <v-card>
      <div class="bt_wrap">
        <div class="popup_top">
          <button class="bt_close" @click="close">닫기</button>
          <span class="s_title">&nbsp;</span>
          <p><span class="b_title">{{ $t(mode === 'edit' ? 'page.meeting-reserve.edit-meeting': 'page.meeting-reserve.create-meeting') }}</span></p>
        </div>

        <form name="formmail">
          <div class="dataTable">
            <table class="custom-tb" cellpadding="0" cellspacing="0">
              <tbody>
                <tr>
                  <td class="data-tb-title">
                    <span class="date_title" id="meetingTitle">회의제목</span>
                  </td>
                  <td class="name" colspan="3">
                    <input type="text" v-model="editedMeetingInfo.title" :placeholder="$t('page.meeting-reserve.meeting-name')"/>
                  </td>
                </tr>
                <tr>
                  <td class="data-tb-title">
                    <span class="date_title" id="meetingDate">일시</span>
                  </td>
                  <td colspan="3">
                    <ul class="meetting_check" style="float: left;">
                      <li style="margin-right: 10px; position:relative; top: 8px;">
                        <input 
                          class="styled-checkbox" 
                          id="styled-checkbox-1" 
                          type="checkbox" 
                          style="z-index: 10; width: 85px;"
                          v-model="editedMeetingInfo.immediateMeeting">
                        <label for="styled-checkbox-1">즉시회의</label>
                      </li>
                    </ul>
                    <div class="date_put">
                      <input type="text" style="letter-spacing: -1px;" disabled class="date1" id="startDate1" :value="meeting.startDate | conferenceDayFilter"> 
                      <div class="img-button" @click="showDatePicker"></div>
                      <v-date-picker
                        class="date-picker"
                        v-bind:style="{display:isActive}"
                        v-model="editedMeetingInfo.startDate" 
                        :min="minDate"
                        no-title 
                        @change="startDateChange"
                      >
                      </v-date-picker>
                      <select class="formbox-time-select" 
                        v-model="editedMeetingInfo.startTime"
                        @change="changedstartTime"
                        :disabled="isTimeFixed || immediateMeeting">
                          <option 
                            v-for="(timeData) in meetingTimeList" 
                            :key="timeData"
                            :value="timeData">{{timeData}}
                          </option>
                      </select>
                      <span>~</span>
                      <select class="formbox-time-select" 
                        v-model="editedMeetingInfo.endTime"
                        @change="changedendTime"
                        :disabled="isTimeFixed">
                        <option 
                          v-for="(timeData) in meetingTimeList" 
                          :key="timeData"
                          :value="timeData">{{timeData}}
                        </option>
                    </select>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td class="data-tb-title">
                    <span class="date_title">공개/비공개</span>
                  </td>
                  <td class="tel" colspan="3">
                    <ul class="meetting_check">
                      <li>
                        <input v-model="editedMeetingInfo.meetingPublicType" 
                              @change="changeMeetingPublicType"
                              class="styled-checkbox" 
                              type="radio" 
                              id="public" 
                              value="public"
                              style="width: 70px; z-index: 10;">
                        <label for="public">공개</label>
                      </li>
                      <li>
                        <input v-model="editedMeetingInfo.meetingPublicType" 
                              @change="changeMeetingPublicType"
                              class="styled-checkbox" 
                              type="radio" 
                              id="private" 
                              value="private"
                              style="width: 50px; z-index: 11;">
                        <label for="private">비공개</label>
                      </li>
                      <li>
                        <input :style="{ display: isPrivate }"
                                type="text" 
                                placeholder="비밀번호를 입력하세요" 
                                style="width:220px; font-size:10pt; margin-left: 13px;" 
                                v-model="editedMeetingInfo.meetingPW"/>
                      </li>
                    </ul>
                    <!-- <input type="text" v-model="meeting.password" name="tel1" />  -->
                  </td>
                </tr>
                <tr>
                  <td class="data-tb-title">
                    <span class="date_title">영상회의실</span>
                  </td>
                  <td class="tel" colspan="3">
                    <ul class="meetting_check">
                      <li>
                        <input v-model="editedMeetingInfo.conferenceRoomActive" 
                              class="styled-checkbox" 
                              type="checkbox" 
                              id="conferenceRoom" 
                              value="conferenceRoom"
                              style="width: 50px; z-index: 11;"
                              :disabled="true">
                        <label for="conferenceRoom">영상회의실 추가</label>
                      </li>
                      <li>
                        <input type="text"
                               style="width:360px; font-size:10pt;" 
                               placeholder="영상회의실 사전 예약 필수"
                               :style="{display:isRoomActive}"
                               :value="selectedConferenceRoomString"
                               @click="openMeetingConferenceDialog()" readonly  name="title" />
                      </li>
                    </ul>
                    <!-- <input type="text" v-model="meeting.password" name="tel1" />  -->
                  </td>
                </tr>
                <tr>
                  <td>
                    <span class="date_title">참석자</span>
                  </td>
                  <td>
                    <ul class="meetting_check">
                      <li>
                        <input type="text" style="width:200px; font-size:13px;" 
                          @click="openMeetingInvitaionDialog()" 
                          placeholder="선택사항"
                          :value="attendeesString"
                          readonly name="title" />
                      </li>
                    </ul>
                  </td>
                  <td style="width: 240px; display:inline-block; line-height:66px;">
                    <span class="date_title" id="editLayout">레이아웃</span>
                  </td>
                  <td class="data-tb-title" style="position:relative; left: 0px; padding-left:0px;">
                    <ul class="meetting_check">
                      <li style="margin-right: 0px;">
                        <input type="text" style="width:255px; font-size:13px; position:relative; left: -100px;" 
                          v-bind:style="{display:isInputLayout}"
                          @click="openMeetingLayoutDialog()" 
                          placeholder="선택사항"
                          readonly name="title" />
                        <img class="fix-layout-img" :src="editedMeetingInfo.layout.selectedLayoutImage" v-bind:style="{display:isLayout}" @click="openMeetingLayoutDialog()">
                      </li>
                    </ul>
                  </td>
                </tr>
                <!-- <tr>
                  <td class="data-tb-title">
                    <span class="date_title">알림유형</span>
                  </td>
                  <td>
                    <ul class="meetting_check">
                      <li>
                        <input class="styled-checkbox" id="styled-checkbox-2" type="checkbox" value="value2" style="width: 30%; z-index: 11;">
                        <label for="styled-checkbox-2">메일</label>
                      </li>
                      <li>
                        <input class="styled-checkbox" id="styled-checkbox-2" type="checkbox" value="value2" style="width: 30%; z-index: 11;">
                        <label for="styled-checkbox-2">메신저</label>
                      </li>
                      <li>
                        <input class="styled-checkbox" id="styled-checkbox-2" type="checkbox" value="value2" style="width: 30%; z-index: 11;">
                        <label for="styled-checkbox-2">카카오톡</label>
                      </li>
                      <li>
                        <input class="styled-checkbox" id="styled-checkbox-2" type="checkbox" value="value2" style="width: 30%; z-index: 11;">
                        <label for="styled-checkbox-2">SMS</label>
                      </li>
                    </ul>
                  </td>
                </tr> -->
                <tr>
                  <td class="data-tb-title">
                    <span class="date_title">선택옵션</span>
                  </td>
                  <td colspan="3">
                    <ul class="meetting_check">
                      <li style="height:50px; line-height: 50px;">
                        <input class="styled-checkbox" id="styled-checkbox-2" type="checkbox" style="width: 80px; z-index: 11;" v-model="meetingLog" :disabled="conferenceRoomActive">
                        <label for="styled-checkbox-2">실시간 &nbsp;&nbsp; 회의록</label>
                      </li>
                      <li style="margin-right: 0px; height:50px; line-height: 50px;">
                        <input class="styled-checkbox" id="styled-checkbox-2" type="checkbox" style="width: 80px; z-index: 11;" v-model="meetingBanner">
                        <label for="styled-checkbox-2">배너추가</label>
                      </li>
                      <li style="position: relative; top: -2px; margin-left: 8px; height:50px; line-height: 50px;" :style="{display: meetingBannerActive}">
                        <select class="formbox-banner-select"
                          v-model="bannerPosition">
                            <option value="bannerTop" selected>상단</option>
                            <option value="bannerDown">하단</option>
                        </select>
                      </li>
                    </ul>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="btnArea">
            <a v-if="meetingInfo && meetingInfo.status === 's' && meetingInfo.conferenceRoomActive === true
                && $store.state.user.email === `seoulAdmin4@seoul.com`"
              class="btn type3" @click="connDevice">영상장비 수동 연결</a>
            <a class="btn type3" @click="editMeeting">수정</a>
            <a class="btn type3 reset" @click="close">취소</a>
            <a class="btn type3 reset" style="background:orange" @click="deleteMeeting">삭제</a>
          </div>
        </form>
      </div>
    </v-card>
    <meeting-invitaion-dialog 
      :dialog="meetingInvitaionDialog.dialog" 
      :noticeInfo="meetingInvitaionDialog.notice"
      :attendeesInfo="meetingInvitaionDialog.attendees"
      :closeMeetingInvitaionDialog="closeMeetingInvitaionDialog"/>

    <meeting-conference-dialog 
      :dialog="meetingConferenceDialog.dialog"
      :closeDialog="closeMeetingConferenceDialog"
      @selectedConferenceRooms="selectedConferenceRooms"/>
      <!-- :meetingInfo="meetingInfo.selectRoom" -->
    <meeting-layout-dialog 
      :dialog="meetingLayoutDialog.dialog"
      @selectedFixSeatList="selectedFixSeatList"
      :attendees="meetingLayoutDialog.attendees"
      :meeetingFixSeatList="meetingLayoutDialog.fixSeatList"
      :selectLayoutCode="meetingLayoutDialog.selectLayoutCode"
      :conferenceRoomActive="conferenceRoomActive"
      :closeMeetingLayoutDialog="closeMeetingLayoutDialog"/>
      <!-- :attendees="meeting.attendees" -->

    <conference-agree-dialog 
      :dialog="conferenceAgreeDialog.dialog"
      :closeDialog="closeConferenceAgreeDialog"/>

    <device-connection-dialog
      :dialog="deviceConnDialog.dialog"
      :meetingInfo="deviceConnDialog.meeting"
      :closeDialog="closeDeviceConnDialog" />
  </v-dialog>
</template>
<script>
import Util from '@/util';

import MeetingCreate from '@/components/meeting/MeetingCreate';
import MeetingInvitaionDialog from '@/components/popup/MeetingInvitaionDialog';
import MeetingConferenceDialog from '@/components/popup/MeetingConferenceDialog';
import MeetingLayoutDialog from '@/components/popup/MeetingLayoutDialog';
import ConferenceAgreeDialog from '@/components/popup/ConferenceAgreeDialog';
import DeviceConnectionDialog from '@/components/popup/DeviceConnectionDialog';

import VueCtkDateTimePicker from 'vue-ctk-date-time-picker';
import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css';

import { Datetime } from 'vue-datetime';
import 'vue-datetime/dist/vue-datetime.css';

import moment from 'moment';
import timezone from 'moment-timezone';
import LoginVue from '../../pages/Login.vue';

export default {
  filters: {
    conferenceDayFilter: function (day) {
      if (day === null) {
        return moment().format('YYYY / MM / DD');
      } else {
        return moment(day).format('YYYY / MM / DD');
      }
    },
    conferenceTimeFilter: function (time) {
      return moment(time).format('HH시 mm분');
    },
    textLengthOverCut (txt, len, lastTxt) {
      if (len === '' || len === null) { 
        len = 5;
      }
      if (lastTxt === '' || lastTxt === null) { 
        lastTxt = '...';
      }
      console.log(txt.length);
      console.log(len);
      if (txt.length > len) {
        txt = txt.substr(0, len) + lastTxt;
        console.log(txt);
      }
      return txt;
    }
  },
  components: {
    MeetingCreate,
    MeetingInvitaionDialog,
    MeetingConferenceDialog,
    VueCtkDateTimePicker,
    datetime: Datetime,
    MeetingLayoutDialog,
    ConferenceAgreeDialog,
    DeviceConnectionDialog
  },
  props: [
    'dialog',
    'closeDialog',
    'meetingInfo',
    'isTimeFixed',
    'isRoomSelectable',
    'isAdminPage',
    'mode'
  ],
  data () {
    return {
      minDate: new Date().toISOString().substr(0, 10),
      startTime: null,
      endTime: null,
      loading: true,
      attendeesString: null,
      selectedConferenceRoomString: null,
      meetingConferenceDialog: {
        dialog: false,
      },
      meetingLayoutDialog: {
        dialog: false,
        attendees: [],
        fixSeatList: [],
        selectLayoutCode: null,
      },
      meetingInvitaionDialog: {
        dialog: false,
        attendees: [],
        notice: {
          email: true,
          kakao: true
        }
      },
      conferenceAgreeDialog: {
        dialog: false,
      },
      layoutFixSeatList: {
        selectedLayoutCode: null,
        selectedLayoutImage: null,
      },
      isPrivate: 'none',
      meetingPublicType: null,
      isActive: 'none',
      isRoomActive: 'none',
      isActiveStartTime: 'none',
      isInputLayout: '',
      isLayout: 'none',
      startDate: null,
      meetingLog: null,
      meetingBanner: false,
      bannerPosition: 'bannerTop',
      meetingBannerActive: 'none',
      conferenceRoomActive: false,
      defaultMeeting: {
        email: null,
        title: null,
        startTime: null,
        endTime: null,
        startDtime: null,
        endDtime: null,
        attendees: [],
        meetingRoom: null,
        meetingRoomId: null,
        roomIds: [],
        password: null,
      },
      editedMeetingInfo: {

      },
      meeting: {
        _id: null,
        email: null,
        title: null,
        startTime: null,
        endTime: null,
        startDtime: null,
        endDtime: null,
        attendees: [],
        roomIds: [],
        password: null,
      },
      error: null,
      immediateMeeting: false,
      repeatSetting: false,
      meetingTimeList: [],
      endTimeList: [],
      selectedConferenceRoom: null,
      selectedConferenceRoomArr: [],
      isIniting: false,
      /**
       * 영상장비 수동 참가 팝업
       */
      deviceConnDialog: {
        dialog: false,
        meeting: null
      }
    };
  },
  computed: {
    reserveHour () {
      let time = this.meeting.startTime;
      if (time !== null) {
        if (time !== '') {
          let hh = time.split('T')[1].split(':')[0];
          let mm = time.split('T')[1].split(':')[1].split(':')[0];
          
          let setHour = '';
          if (mm === 30) {
            hh = parseInt(hh, 10) + 1;
            setHour = moment().format('YYYY-MM-DDT' + hh + ':00:ss');
          } else {
            setHour = moment().add('30', 'm').format('YYYY-MM-DDT' + hh + ':30:ss');
          }

          return setHour;
        }
      }
    },
    getMaxDateTime () {
      return null;
    }
  },
  watch: {
    dialog: {
      handler (val) {
        if (val) {
          this.editedMeetingInfo = Object.assign({}, this.meetingInfo);
          this.loading = false;
          
          this.initMeeting();
        }
      }
    },
    conferenceRoomActive () {
      if (!this.isIniting) {
        if (this.conferenceRoomActive === true) {
          this.isRoomActive = '';
          this.meetingLayoutDialog.selectLayoutCode = null;
          this.layoutFixSeatList.selectedLayoutImage = null;
          this.isInputLayout = '';
          this.isLayout = 'none';
          this.conferenceAgreeDialog.dialog = true;
        } else {
          this.isRoomActive = 'none';
          this.meetingLayoutDialog.selectLayoutCode = null;
          this.layoutFixSeatList.selectedLayoutImage = null;
          this.isInputLayout = '';
          this.isLayout = 'none';
          this.conferenceAgreeDialog.dialog = false;
        }
      } else {
        this.isIniting = false;
        if (this.conferenceRoomActive === true) {
          this.isRoomActive = '';
        } else {
          this.isRoomActive = 'none';
        }
      }
    },
    immediateMeeting: function (val) {
      /* 즉시회의 여기서 작업하시면 됩니다. */
      this.immediateChange(val);
    },
    meetingBanner () {
      this.meetingBanner ? this.meetingBannerActive = '' : this.meetingBannerActive = 'none';
    }
  },
  methods: {
    initMeeting () {
      console.log('** meeting list edit **');
      console.log(`editData : `,this.editedMeetingInfo);
      
      console.log(`?? : `,this.editedMeetingInfo.meetingPublicType);
      /* 패스워드 초기 값 */
      if (this.editedMeetingInfo.meetingPublicType === 'public') {
        this.isPrivate = 'none';
      } else {
        this.isPrivate = '';
      }
    },
    initTimeData (isToday) {
      if (isToday === 'today') {
        this.meetingTimeList = [];
        let meetingInterval = 30;
        let now = this.nowHour();
        let nearestFuture = Util.nearestFutureMinutes(meetingInterval, moment(now));

        let time = nearestFuture.clone();
        let endDate = time.clone().add(1, 'day').format('YYYY-MM-DD');

        while (time.format('YYYY-MM-DD') < endDate) {
          this.meetingTimeList.push(time.format('HH:mm'));
          time = time.add(meetingInterval, 'minutes');
          this.endTimeList.push(time.format('HH:mm'));
        }
      } else {
        this.meetingTimeList = [];
        let meetingInterval = 30;
        let now = this.nowHour();
        let nearestFuture = Util.nearestFutureMinutes(meetingInterval, moment(this.meeting.startDate));

        let time = nearestFuture.clone();
        let endDate = time.clone().add(1, 'day').format('YYYY-MM-DD');

        while (time.format('YYYY-MM-DD') < endDate) {
          this.meetingTimeList.push(time.format('HH:mm'));
          time = time.add(meetingInterval, 'minutes');
          this.endTimeList.push(time.format('HH:mm'));
        }
      }
    },
    openMeetingInvitaionDialog () {
      this.meetingInvitaionDialog.dialog = true;
      this.meetingInvitaionDialog.attendees = this.meeting.attendees;
    },
    openMeetingConferenceDialog () {
      this.meetingConferenceDialog.dialog = true;
    },
    connDevice () {
      this.deviceConnDialog.meeting = {
        _id: this.meeting._id
      };
      this.deviceConnDialog.dialog = true;
    },
    closeMeetingConferenceDialog () {
      this.meetingConferenceDialog.dialog = false;
    },
    closeConferenceAgreeDialog () {
      this.conferenceAgreeDialog.dialog = false;
    },
    closeDeviceConnDialog () {
      this.deviceConnDialog.dialog = false;
    },
    closeMeetingInvitaionDialog (attendees, notice) {
      console.log('# closeMeetingInvitaionDialog #');
      
      if (attendees) {
        if (attendees.length === 1) {
          this.attendeesString = `${attendees[0].name}`;  
        }
        else if (attendees.length > 1) {
          this.attendeesString = this.$t('page.meeting-reserve.attendee-list-string', { name: attendees[0].name, count: attendees.length - 1 });
        } else if (attendees.length === 0) {
          this.attendeesString = null;
        }
        
        this.meetingInvitaionDialog.dialog = false;
        this.meeting.attendees = attendees;
        this.meeting.notice = notice;
      } else {
        this.meetingInvitaionDialog.dialog = false;
        this.meeting.attendees = attendees;
      }

      if (notice) {
        this.meeting.notice.email = notice.email ? notice.email : false;
        this.meeting.notice.kakao = notice.kakao ? notice.kakao : false;
      }
    },
    openMeetingLayoutDialog () {
      /* 레이아웃 설정 */
      console.log(`openMeetingLayoutDialog this.layoutFixSeatList`, this.layoutFixSeatList);
      this.meetingLayoutDialog.attendees = this.meeting.attendees;
      // Layout Code 설정
      if (this.layoutFixSeatList.selectedLayoutCode) {
        this.meetingLayoutDialog.selectLayoutCode = this.layoutFixSeatList.selectedLayoutCode;
        // fixSeatList 설정
        if (this.meetingInfo.fixSeatList && this.meetingInfo.fixSeatList.length >= 1) {
          this.meetingLayoutDialog.fixSeatList = this.meetingInfo.fixSeatList;
        }
      }

      console.log(`meetingInfo.conferenceRoom`, this.meetingInfo.conferenceRoom);
      if (this.conferenceRoomActive && this.meetingInfo.conferenceRoom && this.meetingInfo.conferenceRoom.length >= 1) {
        let concatData = this.meetingInfo.conferenceRoom.map(c => {
          return {
            email: c._id,
            name: c.name
          };
        });
        this.meetingLayoutDialog.attendees = this.meetingLayoutDialog.attendees.concat(concatData);
      }
      console.log(`this.meetingLayoutDialog.attendees`, this.meetingLayoutDialog.attendees);
      this.meetingLayoutDialog.dialog = true;
    },
    closeMeetingLayoutDialog () {
      this.meetingLayoutDialog.dialog = false;
    },
    selectedFixSeatList (selectedLayoutCode, selectedLayoutImage, fixSeatList) {
      /* @emit function */
      console.log('selectedLayoutCode : ' + selectedLayoutCode);
      console.log('selectedLayoutImage : ' + selectedLayoutImage);
      
      let fixSeatCount = 0;
      for (let k = 0; k < fixSeatList.length; k++) {
        console.log(fixSeatList[k].seat);
        if (fixSeatList[k].seat !== null) {
          console.log(fixSeatList[k].seat);
          fixSeatCount++;
        }
      }

      this.isLayout = '';
      this.isInputLayout = 'none';
      this.layoutFixSeatList.selectedLayoutCode = selectedLayoutCode;
      this.layoutFixSeatList.selectedLayoutImage = selectedLayoutImage;

      if (fixSeatCount > 0) {
        this.layoutFixSeatList.fixSeatList = fixSeatList;
      }
      
    },
    close (isInit) {
      if (this.$parent.meetingInfo) {
        this.$parent.meetingInfo.selectRoom = null;
      }
      
      this.selectedConferenceRoom = null;
      this.selectedConferenceRoomArr = [];
      this.immediateMeeting = false;
      // this.initMeeting();
      this.closeDialog(isInit);
    },

    showDatePicker () {
      if (!this.immediateMeeting) {
        if (this.isActive === 'none') {
          this.isActive = '';
        } else {
          this.isActive = 'none';
        }
      }
    },
    startDateChange () {
      this.isActive = 'none';
      this.meeting.startDate = this.startDate;
      let today = moment().utc().format('YYYY-MM-DD');
      let now = this.nowHour();
      
      if (this.meeting.startDate > today) {
        /* 선택한 날짜가 오늘보다 이후이면 */
        // this.meetingInfo.startDtime = moment(this.startDate).utc().format();
        this.initTimeData('after');
      } else if (this.meeting.startDate === today) {
        /* 선택한 날짜가 오늘이면 */
        // this.meetingInfo.startDtime = moment(now).utc().format();
        this.initTimeData('today');
      }
    },
    showStartTimePicker () {
      if (this.isActiveStartTime === 'none') {
        this.isActiveStartTime = '';
      } else {
        this.isActiveStartTime = 'none';
      }
    },
    changedstartTime () {
      console.log(`changedstartTime`);
    },
    changedendTime () {
      console.log(`changedendTime`);
    },
    editMeeting () {
      // 수정 내용 적용
      console.log('?? : ' + this.meeting.startDate);
      let startDtime = moment.tz(this.meeting.startDate + ' ' + this.startTime, moment.tz.guess()).utc().format();
      let endDtime = moment.tz(this.meeting.startDate + ' ' + this.endTime, moment.tz.guess()).utc().format();

      this.meeting.startDtime = startDtime;
      this.meeting.endDtime = endDtime;
      
      const areAllFieldsFilledIn = Object
        .keys(this.meeting)
        .every(key => {
          console.log(this.meeting[key] + '_' + key);
          if (key === 'attendees' || key === 'startTime' || key === 'endTime' || key === 'password' || key === 'meetingRoom' || key === 'meetingRoomId' || key === 'conferenceRoom' || key === 'notice') return true;
          return !!this.meeting[key];
        });

      if (!areAllFieldsFilledIn) {
        alert('필수 값이 입력되지 않았습니다.');
        console.log('필수 값이 입력되지 않았습니다11.');
        this.error = '필수 값이 입력되지 않았습니다.';
        return;
      }

      if (startDtime >= endDtime && !this.immediateMeeting) {
        Util.snackBarOpen(this.$t(`page.meeting-reserve.time-error`), 'error');
        console.log('필수 값이 입력되지 않았습니다22.');
        this.error = this.$t(`page.meeting-reserve.time-error`);
        return;
      }

      let now = moment().utc().format();
      if (now >= endDtime && this.immediateMeeting) {
        Util.snackBarOpen(this.$t(`page.meeting-reserve.end-time-error`), 'error');
        this.error = this.$t(`page.meeting-reserve.end-time-error`);
        return;
      }

      if (this.meeting.conferenceRoomActive === true) {        
        if (this.selectedConferenceRoomArr === 0) {
          Util.snackBarOpen('영상회의실을 추가해주세요', 'error');
          return;
        }
      } else {
        this.meeting.conferenceRoom = null;
      }
      let layoutCode = '';
      let fixSeatList = '';
      let pwdCode = '';
      let params = {
        me: {
          email: this.$store.state.user.email
        },
      };
      
      // if (this.meeting.password !== null) {
      //   pwdCode = '8208=' + this.meeting.password + '&';
      // }

      if (this.layoutFixSeatList.selectedLayoutCode !== null) {
        layoutCode = '4192=0,' + this.layoutFixSeatList.selectedLayoutCode.replace('lay', '') + ',0&';
        fixSeatList = '';

        if (this.layoutFixSeatList.fixSeatList && this.layoutFixSeatList.fixSeatList.length > 0) {
          fixSeatList += '8304=';
          /*
          for (let i = 0; i < item.fixSeatList.length; i++) {
            if (item.fixSeatList[i].seat !== null) {
              fixSeatList += item.fixSeatList[i].id + ',' + '1' + ',' + item.fixSeatList[i].seat.split('_')[0] + ',' + item.fixSeatList[i].seat.split('_')[1];
              fixSeatList += '|';
            }
          }
          */
          const seats = this.layoutFixSeatList.fixSeatList.filter(fixSeat => fixSeat.seat !== null).map(fixSeat => {
            return fixSeat.id + ',1,' + fixSeat.seat.split('_')[0] + ',' + fixSeat.seat.split('_')[1];
          });
          fixSeatList += seats.join('|');
        }
      }
      let roomOption = pwdCode + layoutCode + fixSeatList;

      let meetingInfo = {
        _id: this.meeting._id,
        creator: {
          email: (this.isAdminPage ? this.meetingInfo.creator.email : this.$store.state.user.email),
        },
        title: this.meeting.title,
        startDtime: this.meeting.startDtime, // (new Date(this.meeting.startTime)).toISOString().split('.')[0] + 'Z',
        endDtime: this.meeting.endDtime, // (new Date(this.meeting.endTime)).toISOString().split('.')[0] + 'Z',
        attendees: this.meeting.attendees,
        password: this.meeting.password,
        isImmediately: this.immediateMeeting,
        conferenceRoomActive: this.conferenceRoomActive,
        selectedConferenceRoomArr: this.selectedConferenceRoomArr,
        layoutFixSeatList: this.layoutFixSeatList,
        meetingLog: this.meetingLog,
        meetingBanner: this.meetingBanner,
        bannerPosition: this.bannerPosition,
        roomOption: roomOption,
        notice: this.meeting.notice,
      };
      
      this.loading = true;
      console.log(meetingInfo);
      this.$http.put(`/api/v1/meetings/${meetingInfo._id}`, meetingInfo).then((response) => {
        let ret = response.data;
        let meetingInfo = response.data;
        this.loading = false;
        if (typeof meetingInfo === 'string') {
          this.error = meetingInfo;
        } else {
          this.close(true);
          Util.snackBarOpen(this.$t('page.system-mgr.meeting-composition.edit-meeting-msg'), 'success');
        }
      }).catch(error => {
        console.log(`error`, error);
        this.error = error.response.data.error;
      });
    },
    async deleteMeeting () {
      // 미팅 삭제
      let params = {
        meetingKeys: this.meetingInfo.meetingKey
      };
      await this.$http.delete('/api/v1/meetings', { params: params }).then(response => {
        if (response.data === 'ok') {
          this.close(true);
          Util.snackBarOpen(this.$t('page.system-mgr.meeting-composition.delete-meeting-msg'), 'success');
        }
      }).catch(error => {
        console.log(error);
      });
    },
    selectedConferenceRooms (selectedConferenceRooms) {
      let rooms = '';
      this.selectedConferenceRoomArr = [];
      if (selectedConferenceRooms.length !== 0) {
        for (let i = 0; i < selectedConferenceRooms.length; i++) {
          this.meeting.roomIds.push(selectedConferenceRooms[i]._id);
          if (i === selectedConferenceRooms.length - 1) { 
            rooms += selectedConferenceRooms[i].name;
          } else {
            rooms += selectedConferenceRooms[i].name + ', ';
          }
          this.selectedConferenceRoomArr.push(selectedConferenceRooms[i]);
        }

        if (this.selectedConferenceRoomArr.length > 1) {
          this.selectedConferenceRoomString = this.$t('page.meeting-reserve.conference-list-string', { name: this.selectedConferenceRoomArr[0].name, count: this.selectedConferenceRoomArr.length - 1 });
        } else {
          this.selectedConferenceRoomString = this.selectedConferenceRoomArr[0].name;
        }
      } else {
        this.selectedConferenceRoomString = null;
      }
    },
    immediateChange (immediate) {
      this.isActive = 'none';
      if (immediate) {
        // 시작 시간 => 즉시로 변경
        // 시작 날짜 => 오늘로 변경
        this.meetingTimeList.unshift(this.$t('page.meeting-reserve.immediate'));
        this.startTime = this.meetingTimeList[0];
        this.startDate = moment().format('YYYY-MM-DD');
      } else {
        this.initTimeData('today');
      }
    },
    deleteConferenceRoom (index) {
      this.selectedConferenceRoomArr.splice(index, 1);
    },
    changeMeetingPublicType () {
      if (this.editedMeetingInfo.meetingPublicType === 'public') {
        this.isPrivate = 'none';
        this.editedMeetingInfo.password = null;
      } else {
        this.isPrivate = '';
      }
    },
    nowHour () {      
      let hh = moment().format('HH');
      let mm = moment().format('mm');
      
      let setHour = '';

      if (mm < 30) {
        setHour = moment().format('YYYY-MM-DDTHH:mm:ss');
      } else {    
        setHour = moment().add('1', 'h').format('YYYY-MM-DDTHH:00:00');
      }

      return setHour;
    },
  }
};
</script>
<style scoped>
.pop_top{
  font-weight: 600;
}
.input_meeting{
  border:1px solid #d4d4d4;
  width: 100%;
  vertical-align: middle;
  height: 46px;
  display: inline-block;
  line-height: 2em;
  box-sizing: border-box;
  color: #4e4e4e;
  overflow: hidden;
  text-decoration: none;
  text-indent: 10px;
  border-radius:5px;
}

.datetime-start{
  width: 60%;
  height: 50px;
  border: solid 1px #d4d4d4;
  padding-left: 10px;
  line-height: 50px;
  border-radius: 5px;
  float: left;
}
.datetime-end{
  width: 39%;
  margin-left: 1%;
  height: 50px;
  border: solid 1px #d4d4d4;
  padding-left: 10px;
  line-height: 50px;
  border-radius: 5px;
  float: left;
}

.formbox-time-select{
  width: 24.5%;
  height: 46px;
  font-size: 15px;
  font-weight: 700;
  border: 2px solid #ecedef;
  border-radius: 5px;
  padding-left: 20px;
  margin-left: 0px !important;
  line-height: 40px;
  background-image: url(/static/webex-cloud/images/common/time_ico.png), url(/static/webex-cloud/images/common/selar.png);
  background-position: 70% 52%, 87% 52%;
  background-repeat: no-repeat, no-repeat;
  
  /* background: url(/static/webex-cloud/images/common/selar.png) no-repeat 87% 52%;
  background: url(/static/webex-cloud/images/common/selar.png) no-repeat 25% 52%; */
}

.formbox-banner-select{
  width: 65px;
  height: 30px;
  font-size: 12px;
  font-weight: 100;
  border: 2px solid #dadada;
  border-radius: 5px;
  padding-left: 7px;
  margin-left: 0px !important;
  line-height: 25px;
  background-image: url(/static/webex-cloud/images/common/selar.png);
  background-position: 87% 52%;
  background-repeat: no-repeat;
}


.select-items {
  position: absolute;
  background-color: DodgerBlue;
  top: 100%;
  left: 0;
  right: 0;
  z-index: 99;
}

.meeting-time{
  border: 1px solid #d4d4d4;  
  width : 49%;
  height: 46px;
  float: left;
  text-align: center;
  line-height: 46px;
}

.tbw_p01 .active {
  display: '';
}

.tbw_p01 .noActive {
  display: none;
}

.conferenceroom-btn {
  width: max-content;
  padding-right: 10px;
  height: 30px;
  line-height: 30px;
  margin-top: 5px;
  margin-left: 10px;
  background: #fa4242;
  color: white;
  border-radius: 5px;
  z-index: 5;
  position: relative;
  float: left;
}

.conferenceroom-btn p{
  float: left;
  padding-left: 10px;
}
.conferenceroom-btn img{
  float: left;
  cursor: pointer;
  padding-top: 7px;
  padding-left: 3px;
  width: 8px;
}
.pop_tit{
  height: 20px;
  padding: 30px 0 10px;
  color: #444;
  text-align: left;
  letter-spacing: -1px;
  font-size: 25px;
  text-align: center;
  font-weight: 500;
  line-height: 20px;
  width: 100%;
}
.pop_close{
  position: absolute;
  top: 20px;
  right: 20px;
  display:inline-block;
  width:15px;
  height:15px;
  text-indent: -9999px;
  background: url(/static/webex-cloud/images/common/close_btn.png) center center no-repeat;
}

.popContainer { 
  background: #fff;
  font-size: 16px;
  height: 520px;
}

.v-picker{
  position: absolute;
  z-index: 1000;
  top: 10px;
  right: 120px;
}

.fix-layout-img {
  position: relative;
  width: 70px;
  left: -80px;
  top: 3px;
  cursor:pointer;
}

#bookmarkMeeting{
  width: 100px;
  text-align: center;
  padding: 0;
  font-size: 10pt;
  height: 40px;
  line-height: 40px;
  font-weight: 100;
  position: relative;
  top: -43px;
  left: 175px;
}

.formbox-banner-select{
  width: 65px;
  height: 30px;
  font-size: 12px;
  font-weight: 100;
  border: 2px solid #dadada;
  border-radius: 5px;
  padding-left: 7px;
  margin-left: 0px !important;
  line-height: 25px;
  background-image: url(/static/webex-cloud/images/common/selar.png);
  background-position: 87% 52%;
  background-repeat: no-repeat;
}


.help-bg{
  width: 100%;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  background: black;
  opacity: 0.9;
  z-index: 999;
}
.help-img{
  position: fixed;
  z-index: 1000;
  top: 7%;
  left: 30%;
  width: 750px; 
}

.close-img{
  position: fixed;
  top: 10%;
  right: 20%;
  cursor: pointer;
  z-index: 1001;
}
input::placeholder{
  color: #bfc3c5;
  padding-left: 5px;
}

:-ms-input-placeholder { /* Internet Explorer 10-11 */
    color: #bfc3c5 !important;
    font-size: 1rem !important;
}

</style>



// WEBPACK FOOTER //
// src/components/popup/MeetingListEditDialog.vue